module.exports = __webpack_public_path__ + "static/img/baojian.3ab44bde.png";